import axios from "axios";
const{REACT_APP_SERVICE_URL, REACT_APP_TS_SERVICE_URL} =window.weeksWebCloudConfig;
/**
 * @desc This function is for getting the Component Details by calling the page content Micro Service
 * @param url - page content microserviceUrl
 *       accessToken - Oauth Token for Authorization
 * @return TeamSitePageContentCall - list of teamsite component details based on provided customerId, customerLocale and body path 
**/ 
const headers = {
  'Content-Type': 'text/plain'
};
const setPreviewFlag =()=>{
  //debugger;
  return window.location.href.indexOf("preview") > -1 ? true : false;
}

  export const TeamSitePageContentCall =  async (customerId,customerLocale) =>{
    //debugger;
    let isPreviewFlag = setPreviewFlag();
    //let queryParam = `consumerChannelQ=Web&memberTypeQ=POINTS&operatorIdQ=WEB00USER&customerIdQ=${customerId}`
    //debugger;  
    let pageContentRes = ""
      const URL = isPreviewFlag ? `${REACT_APP_TS_SERVICE_URL}/utility/teamsite/page-content?isPreview=true` : `${REACT_APP_TS_SERVICE_URL}/utility/teamsite/page-content`
     
      
      const queryParam = {
        consumerChannelQ : "Web",
        memberTypeQ: "WEEKS",
        operatorIdQ: "WEB00USER", 
        customerIdQ:customerId,
        /* Authorization: `Bearer ${access_token}` */ } 
        //const corsCredential = {withCredentials: true}
      //const axiosParams = {params:{customerId:customerId}}
      const body = {"path": `/iwov-resources/json/post-wow-${customerLocale}/replatform/postlogin-home.json`}
      try {
        /* pageContentRes = await axios.post(URL,body,{
          ...headers,
          ...corsCredential
        }); */
        pageContentRes = await axios({url:URL,method: 'post', headers:headers, params:queryParam, data:body, withCredentials: true});
        //debugger;
        return pageContentRes.data;
      } catch (error) {
        // pageContentRes = error.response;
        // return pageContentRes.data;
        //debugger;
        window.location.href = `/post-wow-${customerLocale}/error.page`; 
      } 
     }
/**
 * @desc This function is for getting the temasite Component Response by calling the Component Details Micro Service
 * @param url - componentDetails microserviceUrl
 *       accessToken - access token from redux store for Authorization
 * @return TeamSiteComponentDetailsCall - list of All compoenet details based on provided component body
**/ 

     export const TeamSiteComponentDetailsCall =  async (...tsArg) =>{
      let isPreviewFlag = setPreviewFlag();
       const access_token=tsArg[0].accessToken;
       const customerId=tsArg[0].customerId;
       const TSCompContentData=tsArg[0].TScompContentBody;
      //const customerLocale=tsArg[0].customerLocale;
      //console.log("in ts-->",access_token,customerId,TSCompContentData)
        const bodyDataConfig = {
            cascadedDCR: TSCompContentData.cascadedDCR,
            componentajaxURL: TSCompContentData.componentajaxURL,
            defaultRule: TSCompContentData.defaultRule,
            honorPublicationDates: TSCompContentData.honorPublicationDates,
            id: TSCompContentData.id,
            location: TSCompContentData.location,
            name: TSCompContentData.name,
            ruleSelection: TSCompContentData.ruleSelection,
            selectedSkin: TSCompContentData.selectedSkin,
            customerId: customerId,
            isSimonDataDependent:TSCompContentData.isSimonDataDependent
        }
        const corsCredential = {withCredentials: true}
        let pageContentRes = ""
        const URL = isPreviewFlag ? `${REACT_APP_TS_SERVICE_URL}/utility/teamsite/component-details?isPreview=true` : `${REACT_APP_TS_SERVICE_URL}/utility/teamsite/component-details`
        const queryParam = { 
          consumerChannelQ : "Web",
          memberTypeQ: "WEEKS",
          operatorIdQ: "WEB00USER", 
          customerIdQ:customerId,
         /*  Authorization: `Bearer ${access_token}` */
         } 
        
        try {
          /* pageContentRes = await axios.post(URL,bodyDataConfig,{
            ...headers,
            ...corsCredential
          }); */
          pageContentRes = await axios({url:URL,method: 'post',
          params:queryParam, headers:headers, data:bodyDataConfig, withCredentials: true
          })
          return pageContentRes;
        } catch (error) {
          pageContentRes = error.response;
          return pageContentRes;
        }
         
       }



       export const TeamSiteOfferDetailsCall =  async (...tsArg) =>{
        const access_token=tsArg[0].accessToken;
        const customerId=tsArg[0].customerId;
        const TSCompContentData=tsArg[0].TScompContentBody;
       //const customerLocale=tsArg[0].customerLocale;
       //console.log("in ts-->",access_token,customerId,TSCompContentData)
         const bodyDataConfig = {
             cascadedDCR: TSCompContentData.cascadedDCR,
             componentajaxURL: TSCompContentData.componentajaxURL,
             defaultRule: TSCompContentData.defaultRule,
             honorPublicationDates: TSCompContentData.honorPublicationDates,
             id: TSCompContentData.id,
             location: TSCompContentData.location,
             name: TSCompContentData.name,
             ruleSelection: TSCompContentData.ruleSelection,
             selectedSkin: TSCompContentData.selectedSkin,
             customerId: customerId,
             isSimonDataDependent:TSCompContentData.isSimonDataDependent
         }
         let pageContentRes = ""
         const URL = `${REACT_APP_SERVICE_URL}/rcio/utility/teamsite/offer-details`
         const queryParam = {  
          consumerChannelQ : "Web",
          memberTypeQ: "WEEKS",
          operatorIdQ: "WEB00USER", 
          customerIdQ:customerId,
        //   Authorization: `Bearer ${access_token}`,
        //   withCredentials:true 
        }
         
         try {

          pageContentRes = await axios({url:URL,method: 'post',
          params:queryParam, headers:headers, data:bodyDataConfig, withCredentials: true
          })
         //  pageContentRes = await axios.post(URL,bodyDataConfig,headers);
           return pageContentRes;
         } catch (error) {
           pageContentRes = error.response;
           return pageContentRes;
         }
          
        }